import script from "./SubscriptionPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionPage.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionPage.vue?vue&type=style&index=0&id=70099e42&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70099e42"]])

export default __exports__